import { Modal, Button } from "components/ui/BootstrapCompat";
import { Formik, Form } from "formik";
import CustomInput from "../CustomInput";
import { errorAdd, successAdd } from "helpers/sweetalert";

interface Props {
  open: boolean;
  onClose: () => void;
  callback?: (value: any) => void;
}

export default function PopUpWithdrawRequest({ open, onClose, callback }: Props) {
  const onSubmit = async (values: any) => {
    try {
      callback?.(values);
      successAdd("ເພີ່ມການເບີ່ງເງິນສຳເລັດ");
      onClose();
    } catch (error: any) {
      errorAdd(error?.response?.data?.message || "ເກີດຂໍ້ຜິດພາດ");
    }
  };

  return (
    <Modal show={open} onHide={onClose} keyboard={false} centered>
      <Modal.Header closeButton>
        <Modal.Title>ແບບຟອມແຈ້ງຖອນເງິນ</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{
          amount: "",
          bankName: "",
          accountName: "",
          accountNumber: "",
          note: "",
        }}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form>
            <Modal.Body>
              <div className="flex flex-col gap-3">
                <CustomInput
                  require
                  label="ຈຳນວນເງິນທີ່ຕ້ອງການຖອນ"
                  name="amount"
                  type="number"
                  placeholder="ເພີ່ມຈຳນວນເງິນ"
                />
                <CustomInput
                  require
                  label="ຊື່ບັນຊີ"
                  name="accountName"
                  type="text"
                  placeholder="ເຊັ່ນ ນາມສະກຸນ ບັນຊີ"
                />
                <CustomInput
                  require
                  label="ເບີບັນຊີ"
                  name="accountNumber"
                  type="text"
                  placeholder="ເບີບັນຊີ"
                />
                <CustomInput
                  require
                  label="ທະນາຄານ / ຜູ້ປູກເຕີ"
                  name="bankName"
                  type="text"
                  placeholder="ເຊັ່ນ BCEL, LDB, ບັນຊີເງິນ"
                />
                <CustomInput
                  label="ໝາຍເຫດ"
                  name="note"
                  as="textarea"
                  placeholder="ເພີ່ມໝາຍເຫດເພີ່ມເຕີມ (ຕົວເລື່ອງ)"
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={onClose}>
                ຍົກເລີກ
              </Button>
              <Button
                variant="primary"
                type="submit"
                disabled={isSubmitting}
                className="w-full sm:w-auto"
              >
                ສົ່ງແຈ້ງຖອນ
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
